import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { unwrappedComparisonTeamNameAtom } from '@/atoms/queries/team/teamComparison';
import { unwrappedSelectedTeamNameAtom } from '@/atoms/team/info';
import { ComparisonFilterTabs } from '@/components/filters/ComparisonFilterTabs';
import { useIsCompetitionAverageMode } from '@/hooks/useIsCompetitionAverageMode';
import { TeamComparisonHighLevelFilters } from './TeamComparisonHighLevelFilters';
import { TeamCompetitionAveragePanel } from './TeamCompetitionAveragePanel';
import { TeamHighLevelFilters } from './TeamHighLevelFilters';

export const TeamFilterTabs = () => {
  const { t } = useTranslation('radar');
  const primaryName = useAtomValue(unwrappedSelectedTeamNameAtom);
  const entityComparisonName = useAtomValue(unwrappedComparisonTeamNameAtom);
  const isCompetitionAverageMode = useIsCompetitionAverageMode();
  const comparisonName = isCompetitionAverageMode ? t('competitionAverage.optionLabel') : entityComparisonName;

  return (
    <ComparisonFilterTabs
      primaryName={primaryName}
      comparisonName={comparisonName}
      primaryFilters={<TeamHighLevelFilters />}
      comparisonFilters={
        isCompetitionAverageMode ? <TeamCompetitionAveragePanel /> : <TeamComparisonHighLevelFilters />
      }
    />
  );
};
